import { render, staticRenderFns } from "./Immobile.vue?vue&type=template&id=1cb0f076&scoped=true&"
import script from "./Immobile.vue?vue&type=script&lang=js&"
export * from "./Immobile.vue?vue&type=script&lang=js&"
import style0 from "./Immobile.vue?vue&type=style&index=0&id=1cb0f076&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cb0f076",
  null
  
)

export default component.exports